import { render, staticRenderFns } from "./Managezb.vue?vue&type=template&id=d221d60a&scoped=true&"
import script from "./Managezb.vue?vue&type=script&lang=js&"
export * from "./Managezb.vue?vue&type=script&lang=js&"
import style0 from "./Managezb.vue?vue&type=style&index=0&id=d221d60a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d221d60a",
  null
  
)

export default component.exports